<template>
    <OverlayLoading 
       :loadingPage = loadingPage
    />
    <div class="mainHolder">
        <div id="sec-one">
            <div class="outer">
                <div class="content">
                    <div class="item">
                        <div id="leftPanel" class="settingPanel">
                            <TopBar/>

                            <!--
                            
                            -->

                            <div class="sectionSettingAdminDetail" v-if="isAdmin">
                                <div id="mainMenuSelected">SETTINGS</div>
                                <button class="btnAddNewUser" @click="setNewUser()" :class="{ activeUser : newUserSelected  }">ADD USER</button>

                                <!--
                                <p class="infoOption">Existing users list:</p>
                                <button  @click="sort('name')">
                                        Name
                                </button>
                                <button  @click="sort('createdAt')">
                                        Date
                                </button>
                                -->
                                <form @submit.prevent="getUsers()">
                                    <div class="search">
                                            <input 
                                                type="text" 
                                                class="searchTerm" 
                                                placeholder="Search user"
                                                v-model="keyword"
                                            >
                                            <button type="submit" class="searchButton">
                                                <i class="fa fa-search"></i>
                                            </button>
                                    </div>
                                    <div class="text-right pb30"><a href="#" @click.prevent="resetReach" class="resetSearch">Reset search</a></div>
                                </form>
                                <div v-if="sortedDataUsers.length === 0">
                                    <div class="alert error">No records found</div>
                                </div>
                                <div id="holderListUsers">
                                    
                                    <table>
                                        <tbody>
                                            <tr v-for="(item, key) in sortedDataUsers" :key="key" :class="{ activeUser : userIdSelected === item.id  }" @click="selectUser(item.id)" :id="item.id">
                                                <td style="width:100px" >
                                                    <img src="../assets/images/image-profile-white.png" class="pictureUser white">
                                                    <img src="../assets/images/image-profile.png" class="pictureUser red">
                                                </td>
                                                <td class="infoUsername">   
                                                    <span class="name">{{ item.name }}</span>
                                                    <span class="angleRight"><i class="fal fa-angle-right"></i></span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            <!--
                            <div class="fa-3x holderLoadingHistory" v-if="loadingPage">
                                <i class="fas fa-spinner fa-spin"></i>
                            </div>
                            -->
                            <div class="holderPagination" v-if="pages > 1 ">  
                                
                                <!-- debug: sort={{currentSort}}, dir={{currentSortDir}} -->
                                <nav 
                                    class="pagination"
                                    role="navegation"
                                    aria-label="pagination"
                                >
                                <ul>
                                    <li>
                                        <button 
                                            class="pagination-previous" 
                                            @click.prevent="changePage( page - 1 )"
                                            :disabled="page == 1"
                                        >
                                            Prev
                                        </button>
                                    </li>
                                   
                                        
                                            <li>
                                                <button  class="pagination-link is-current">{{ page }}</button>
                                            </li>
                                       <li>  
                                        <button    
                                            class="pagination-next" 
                                            @click.prevent="changePage( page + 1 )"
                                            :disabled="page == pages"
                                        >
                                            Next
                                        </button>
                                       </li>
                                    </ul>
                                </nav>    
                            </div>
                            </div>
                            <div class="sectionHistoryDetail" v-else>
                                <div id="mainMenuSelected">SETTINGS</div>
                                <p class="infoOption">Welcome to your profile settings.</p>
                            </div>
                            
                            <div class="mainManu">
                                <div>
                                    <router-link to="/" class="navbar-brand">
                                        BACK TO MAIN MENU
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div id="sec-two" >
            <div class="outer">
                <div class="content">
                    <div class="p15">
                        <Logo className="item pt30 smallMainLogo"/>
                    </div>
                    
                    <div class="bg-settings">
                        <br>
                        <!-- Is Admin -->
                        <div v-if="isAdmin">
                            <!-- show info user selected -->
                            <div  v-if="!newUserSelected">
                                <form @submit.prevent="updateUser">
                                    <div class="content-schedule" >
                                        <div class="showInfoUser">
                                            <img src="../assets/images/image-profile-big.png">
                                            <div id="selectedInfo">Selected user information:</div>
                                            <div  class="detailUser holderUpdateUser">    
                                                <div>
                                                    <span class="description">USERNAME:</span>
                                                    <span class="itemUser" v-if="userDataSelected[0] && userDataSelected[0].name && !openInputsUpdate ">{{ userDataSelected[0].name }} </span>
                                                    <span  v-if="userDataSelected[0] && userDataSelected[0].name && openInputsUpdate "><input type="text" v-model="dataFormUser.username" > </span>
                                                </div>
                                                <div>
                                                    <span class="description">USER EMAIL:</span> 
                                                    <span class="itemUser" v-if="userDataSelected[0] && userDataSelected[0].email && !openInputsUpdate">{{ userDataSelected[0].email }} </span>
                                                    <span v-if="userDataSelected[0] && userDataSelected[0].email && openInputsUpdate"><input type="email" v-model="dataFormUser.email" > </span>
                                                </div>
                                                <div >
                                                    <span class="description">USER TYPE:</span> 
                                                    <span v-if="userDataSelected[0] && userDataSelected[0].primaryRole && !openInputsUpdate">
                                                        <input type="radio" name="userType" id="admin" value="admin" v-model="userDataSelected[0].primaryRole">
                                                        <label class="itemUser" for="admin">Admin</label>
                                                        <input type="radio" name="userType" id="user" value="user" v-model="userDataSelected[0].primaryRole">
                                                        <label class="itemUser" for="user">Member</label>
                                                    </span>
                                                    <span v-if="userDataSelected[0] && userDataSelected[0].primaryRole && openInputsUpdate">
                                                        <input type="radio" name="userType" id="admin" value="admin" v-model="dataFormUser.type">
                                                        <label class="itemUser" for="admin">Admin</label>
                                                        <input type="radio" name="userType" id="user" value="user" v-model="dataFormUser.type">
                                                        <label class="itemUser" for="user">Member</label>
                                                    </span>
                                                </div>  
                                                <div v-if="openInputsUpdate">
                                                    <div >
                                                        <span class="description"><label for="changePass"> RESET PASSWORD: </label></span><input type="checkbox" id="changePass" value="1" v-model="openToChangePassword">
                                                    </div>
                                                
                                                    <div v-if="openToChangePassword">
                                                        <div><span class="description">PASSWORD:</span> <span><input type="password" v-model.trim="dataFormUser.password" required></span></div>
                                                        <div><span class="description">REPEAT PASSWORD:</span> <span><input type="password" v-model.trim="dataFormUser.repeat_password" required></span></div>
                                                    </div>                                  
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="gridBtns" v-if="userIdSelected">
                                        <button
                                            class=""
                                            type="button"
                                            @click="deleteUser()"
                                            v-if="!openInputsUpdate"
                                        >
                                            DELETE USER
                                        </button>
                                        <button
                                            class=""
                                             
                                            @click="cancelUpdate()"
                                            v-else
                                        >
                                            CANCEL
                                        </button>

                                        <button
                                                class=""
                                                
                                                @click="openResetPassword"
                                                v-if="!openInputsUpdate"
                                            >UPDATE
                                        </button>
                                        <button
                                                class=""
                                                type="submit"  
                                                
                                                v-else
                                            >SAVE
                                        </button>
                                    </div>
                                </form>
                                <br><br>
                            </div>
                            <!-- Create new user -->
                            <div  v-else> 
                                <form  @submit.prevent="sendFormNewUser">   
                                    <div class="content-schedule">
                                        <div class="showInfoUser">
                                            <img src="../assets/images/image-profile-big.png">
                                            <div id="selectedInfo">Add a New User:</div>
                                            <div  class="detailUser holderCreateUser">    
                                                <div><span class="description">USERNAME:</span> <span><input type="text" v-model.trim="dataFormUser.username" required></span> </div>
                                                <div><span class="description">USER EMAIL:</span> <span><input type="email" v-model.trim="dataFormUser.email" required></span></div>
                                                <div><span class="description">USER TYPE:</span> 
                                                    <span>
                                                        <input type="radio" name="userType" id="admin" value="admin" v-model="dataFormUser.type" required>
                                                        <label class="itemUser" for="admin">Admin</label>
                                                        <input type="radio" name="userType" id="user" value="user" v-model="dataFormUser.type" required>
                                                        <label class="itemUser" for="user">Member</label>
                                                    </span>
                                                </div>                                    
                                                <div><span class="description">PASSWORD:</span> <span><input type="password" v-model.trim="dataFormUser.password" required></span></div>
                                                <div><span class="description">REPEAT PASSWORD:</span> <span><input type="password" v-model.trim="dataFormUser.repeat_password" required></span></div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="gridBtns">
                                        <button
                                                class=""
                                                type="submit"  
                                            
                                            >CREATE
                                            <!--<span v-if="!sendingForm">SEND</span> <span class="fa-1x" v-if="sendingForm"><i class="fas fa-spinner fa-spin redColor"></i></span> -->
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <!-- Is Normal User -->
                        <div v-else>
                            <form  @submit.prevent="updateUser">
                                <div class="content-schedule" >
                                    <div class="showInfoUser">
                                        <img src="../assets/images/image-profile-big.png">
                                        <div id="selectedInfoNormalUser">User information:</div>
                                        <div  class="detailUser holderUpdateUser">    
                                            <div><span class="description">USERNAME:</span><span class="itemUser" v-if="userDataSelected[0] && userDataSelected[0].name">{{ userDataSelected[0].name }} </span> </div>
                                            <div><span class="description">USER EMAIL:</span> <span class="itemUser" v-if="userDataSelected[0] && userDataSelected[0].email">{{ userDataSelected[0].email }} </span></div>
                                            <div v-if="openInputsUpdate"><span class="description" >PASSWORD:</span> <span><input type="password" v-model.trim="dataFormUser.password" required></span></div>
                                            <div v-if="openInputsUpdate"><span class="description"  >REPEAT PASSWORD:</span> <span><input type="password" v-model.trim="dataFormUser.repeat_password"  required></span></div>                                   
                                        </div>
                                    </div>
                                </div>

                                <div class="holderBtnOne" >
                                    <button
                                        class=""  
                                        v-if="!openInputsUpdate"
                                        @click="openResetPassword"
                                    >
                                        RESET PASSWORD
                                    </button>
                                    <button
                                        class=""
                                        type="submit"  
                                        v-if="openInputsUpdate"
                                    >
                                        SAVE CHANGES
                                    </button>
                                </div>
                                <br><br>
                            </form>
                        </div>

                        
                        <div class="schedule-form">
                            
                        </div>

                       
                         <br>
                         <br>
                         <br>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
</template>

<script>
import OverlayLoading from '../components/OverlayLoading.vue'
import TopBar from '../components/TopBar.vue'
import MainMenu from '../components/MainMenu.vue'
import Logo from '../components/Logo'
import axios from "axios";

//Datatable Modules
//import "datatables.net-dt/js/dataTables.dataTables"
//import "datatables.net-dt/css/jquery.dataTables.min.css"
import $ from 'jquery'; 

export default {
    props:['templates_data'],
    components: {
        TopBar,
        MainMenu,
        Logo,
        OverlayLoading
    },
    data() {
        return {
            user_info: [],
            isAdmin: true,
            data_users:[],
            loadingPage: false,  

            userIdSelected:'',
            isActive: false,

            userDataSelected:[],

            newUserSelected: false,

            openInputsUpdate: false,
            
            //Data New User
            dataFormUser:{
                username:'',
                email:'',
                password:'',
                repeat_password: '',
                type:'',
            },
            
            //For admin
            openToChangePassword: "",

            //Pagination
            page: 1,
            pages: "",
            currentSort:'name',
            currentSortDir:'asc',

            keyword: "",
            
        };
    },
    watch: {
        keyword(newKeyword, oldKeyword) {
            console.log(" New " + newKeyword)
            if( newKeyword.length > 3 )
            {
                //this.getUsers()
            }
            
            //console.log(" Old " + oldKeyword)
            //if (!this.keyword) return;
            //this.debounceName();
        }
    },
    mounted(){
    },
    computed:{
        sortedDataUsers:function() {
            return this.data_users.sort((a,b) => {
                let modifier = 1;
                if(this.currentSortDir === 'desc') modifier = -1;
                if(a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
                if(a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
                return 0;
            });
        }
    },
    created(){
        this.user_info = JSON.parse(localStorage.getItem('user_info'))
        if( this.user_info.data.primaryRole.name === "user")
        {
            this.isAdmin = false
            this.openInputsUpdate = false
        }

        this.getUsers()
    }, 
    methods:{
        
        resetReach(){
            this.keyword = ""
            this.getUsers()
        },
        selectUser(id){
            this.userIdSelected = id;

            let output =  this.data_users.filter(item => item.id === id);
            this.userDataSelected = output

            this.newUserSelected = false
            this.openInputsUpdate = ""

            //let arrData = [];
            let dataFormUser = {
                    username: this.userDataSelected[0].name, 
                    email: this.userDataSelected[0].email, 
                    type: this.userDataSelected[0].primaryRole,
        
            }
            this.dataFormUser = dataFormUser;
            //console.log(this.dataFormUser)
        },

        async getUsers(){
            const self = this;

            if( !this.isAdmin){
                //Its normal user
                let arrData = [];
                arrData.push({
                            id: this.user_info.data.id, 
                            name: this.user_info.data.name, 
                            email: this.user_info.data.email,
                            primaryRole: this.user_info.data.primaryRole.name, 
                        })
                this.userDataSelected = arrData;
                this.userIdSelected = this.user_info.data.id
                return false
            }
            self.loadingPage = true;

            let urlUsers = "";
            if(self.keyword !== "")
            {
                urlUsers = `users?&q=${self.keyword}&page=${this.page}`;
            }else{
                urlUsers = `users?page=${this.page}`;
            }

            await axios({
                method: "get",
                url: urlUsers, //`users?page=${this.page}`,
                responseType: "json",
                //data: params,
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: "Bearer " + localStorage.getItem('token')//dataUser.data.jwt
                }
            })
            .then(function(response) {
                if (response.data) {
                    let arrData = [];

                    self.pages = (response.data.meta.pagination.totalPages) //Get Total pages
                    response.data.data.forEach(element => {
                        arrData.push({
                            id:element.id, 
                            name: element.name, 
                            email: element.email,
                            primaryRole:element.primaryRole.name,
                            createdAt:element.primaryRole.createdAt, 
                        })
                        
                    });

                    /*
                    var byName = arrData.slice(0);
                    byName.sort(function(a,b) {
                        var x = a.name.toLowerCase();
                        var y = b.name.toLowerCase();
                        return x < y ? -1 : x > y ? 1 : 0;
                    });
                    self.data_users = byName
                    */
                   self.data_users = arrData

                    self.loadingPage = false

                    
                    $(document).ready(function(){
                    });
                    
                }else{
                    self.callToast(`There was an error`, 'warning')
                }

                self.loadingPage = false
            })
            .catch(error => (self.callToast(`${error.response.data.message}`, 'warning'), (self.loadingPage = false), console.log(error.response.data)));   
        },

        callToast(message, status){
            this.$toast.show(message, {
                type: status,
                position: 'top-right'
                // all of other options may go here
            });
        },

        changePage(page){
            
            this.page = (page <= 0 || page > this.pages)? this.page : page
            //alert(this.page)
            this.getUsers()
        },

        sort(s) {
            //console.log("xxx");
            //if s == current sort, reverse
            if(s === this.currentSort) {
                this.currentSortDir = this.currentSortDir==='asc'?'desc':'asc';
            }
            this.currentSort = s;
        },

        setNewUser(){
            this.newUserSelected = true;
            this.userIdSelected = ""
            this.userDataSelected = []
            this.dataFormUser = []
        },

        async sendFormNewUser(){
            const self = this
            if( self.dataFormUser.password != self.dataFormUser.repeat_password)
            {
                self.callToast(`Passwords are not equal`, 'warning')
                return false
            }

            let formData = new FormData();
            formData.append("name", self.dataFormUser.username);
            formData.append("email", self.dataFormUser.email);
            formData.append("password", self.dataFormUser.password);
            formData.append("role", self.dataFormUser.type);

            //Send form
            self.loadingPage = true;

            await axios({
                method: "post",
                url: `users`,
                responseType: "json",
                data: formData,
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: "Bearer " + localStorage.getItem('token')//dataUser.data.jwt
                }
            })
            .then(function(response) {
                if (response.data) {

                    //Call users list
                    self.getUsers();
                   
                    self.callToast(`User was successfully created!`, 'success')
                    self.dataFormUser = {
                        username:'',
                        email:'',
                        password:'',
                        repeat_password: '',
                        type:'',
                    }
                    
                }else{
                    self.callToast(`There was an error`, 'warning')
                }

                self.loadingPage = false
            })
            .catch(error => (self.callToast(`${error}`, 'warning'), (self.loadingPage = false))); 
        },

        async deleteUser(){
            //Send form
            this.$swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.doDelete();
                    /*
                    this.$swal.fire(
                        'Deleted!',
                        'Your file has been deleted.',
                        'success'
                    )
                    */
                }
            })
        },

        async doDelete(){
            const self = this
            self.loadingPage = true
            await axios({
                method: "delete",
                url: `users/${self.userIdSelected}`,
                responseType: "json",
                //data: formData,
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + localStorage.getItem('token')//dataUser.data.jwt
                }
            })
            .then(function(response) {
                if (response.data.status === true) {

                    //Call users list
                    self.getUsers();
                   
                    self.callToast(`User was successfully deleted!`, 'success')
                
                    self.userIdSelected = ""
                    self.userDataSelected = ""
                    self.dataFormUser = {
                        username:'',
                        email:'',
                        password:'',
                        type:'',
                    }
                    
                }else{
                    self.callToast(`There was an error`, 'warning')
                }

                self.loadingPage = false
            })
            .catch(error => (self.callToast(`${error.response.data.message}`, 'warning'), (self.loadingPage = false)));
        },

        async updateUser(){
            const self = this

            let formData = new FormData();   
            if( self.isAdmin )
            {
                formData.append("name", self.dataFormUser.username);
                formData.append("email", self.dataFormUser.email);
                //formData.append("password", self.dataFormUser.password);
                formData.append("role", self.dataFormUser.type);
                if(self.openToChangePassword)
                {
                    if( self.dataFormUser.password == self.dataFormUser.repeat_password )
                    {
                        formData.append("password", self.dataFormUser.password);
                    }
                    else
                    {
                        self.callToast(`Passwords are not equal`, 'warning')
                        return false
                    }
                }

            }else{
                formData.append("name", self.userDataSelected[0].name);
                formData.append("email", self.userDataSelected[0].email);
                if( self.dataFormUser.password == self.dataFormUser.repeat_password )
                {
                    formData.append("password", self.dataFormUser.password);
                }
                else
                {
                    self.callToast(`Passwords are not equal`, 'warning')
                    return false
                }
                
                formData.append("role", self.userDataSelected[0].primaryRole);
            }

            var object = {};
            formData.forEach(function(value, key){
                object[key] = value;
            });
            var json = JSON.stringify(object);
            
            self.loadingPage = true
            
            await axios({
                method: "put",
                url: `users/${self.userIdSelected}`,
                responseType: "json",
                data: json,
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + localStorage.getItem('token')//dataUser.data.jwt
                }
            })
            
            //const body = {};
            /*
            await axios.put(`users/${self.userIdSelected}`, json, {
                headers: {
                    
                    "Content-Type": "application/json",
                     Authorization: "Bearer " + localStorage.getItem('token')//dataUser.data.jwt
                }
            })
            */
            .then(function(response) {
                if (response.data) {

                    //Call users list
                    self.getUsers();
                   
                    
                    //Close Update Form
                    self.cancelUpdate();
                    self.dataFormUser = {
                        username:'',
                        email:'',
                        password:'',
                        repeat_password: '',
                        type:'',
                    }
                    
                    //Active the current user selected
                    self.selectUser(self.userIdSelected)
                    

                    //Get user data selected
                    let arrData = []
                    arrData.push({
                            id:response.data.data.id, 
                            name: response.data.data.name, 
                            email: response.data.data.email,
                            primaryRole:response.data.data.name,
                            createdAt:response.data.data.createdAt, 
                        })
                    self.userDataSelected = arrData
                   
                    self.callToast(`User was successfully updated!`, 'success')
                    if( !self.isAdmin ){
                        self.$store.commit('logout')
                    }
                    
                }else{
                    self.callToast(`There was an error`, 'warning')
                }

                self.loadingPage = false
            })
            .catch(error => (self.callToast(`${error}`, 'warning'), (self.loadingPage = false)));
            
        },

        openResetPassword(){
            this.openInputsUpdate = true
        },
        cancelUpdate(){
            this.openInputsUpdate = false
            this.openToChangePassword = ""
            
        }
    }
}
</script>

<style>

</style>